export function getSearchStudents(searchFilters, students) {
    if (!Array.isArray(students))
        return []

    const lowerString = searchFilters.string.toLocaleLowerCase()
    const tmpStudents = JSON.parse(JSON.stringify(students))

    return tmpStudents.map((student) => {
        if (searchFilters.subjects.length > 0) {
            let hasSubjectCounter = 0
            let purchaseArray = student.purchases.map(p => p.classtype_title)
            for (let subj of searchFilters.subjects)
                if (purchaseArray.includes(subj))
                    hasSubjectCounter++
            if (hasSubjectCounter !== searchFilters.subjects.length)
                return
        }

        const name = `${student.last_name} ${student.first_name}`.toLocaleLowerCase()
        const startGoal = searchFilters.start_goal ? Number(searchFilters.start_goal) : 0
        const endGoal = searchFilters.end_goal ? Number(searchFilters.end_goal) : 100

        if ( name.includes(lowerString) || student.email.includes(lowerString) ) {
            student.purchases = student.purchases.filter(p => 
                p.studentclasstypegoal_number_of_points >= startGoal &&
                p.studentclasstypegoal_number_of_points <= endGoal
            )

            if (student.purchases.length)
                return student
        }
    })
}
